import React, { createRef, useState } from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { TimeIcon } from '../Icon';
import { classNames } from '../../utils';
import TimeSelectPop from './TimeSelectPop';
const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
    // alignItems: 'center',
    // width: '17.188rem',
    // height: '3.5rem',
    // padding: '0 0.438rem 0 1.25rem',
    // borderRadius: '10px',
    // border: 'solid 1px #e4e7eb',
    // backgroundColor: '#fff',
    // margin: '100px',
    position: 'relative',
  },
  keyboardTimePicker: {
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  iconButton: {
    width: '3rem',
    height: '3rem',
    position: 'absolute',
    right: '0',
    top: '0.25rem',
    // transform: 'translateY(-50%)',
  },
  timeIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#538fff',
  },
  datepicker: {
    width: '100%',
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      flex: '50%',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  dateIcon: {
    color: '#f00',
  },
  disabledStyle: {
    '& .MuiInputBase-root': {
      backgroundColor: '#f5f5f5',
    },
  },
}));

export default function KeyboardTimeInput({
  className,
  placeholder,
  onChange,
  value,
  disabled,
  onBlur,
  disableFuture,
  date,
  id,
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleKeyDownInput = () => {
    const input = inputRef.current.querySelector(`[value="${value}"]`);
    if (input?.value) {
      if (input.value.includes('PM') || input.value.includes('AM')) {
        if (input.selectionStart > input.value.length - 3) {
          input.setSelectionRange(input.value.length - 2, input.value.length);
        }
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 8) {
      const value = e.target.value;
      if (value.includes('A') || value.includes('P')) {
        handleKeyDownInput();
      }
    }
  };

  const inputRef = createRef(null);

  return (
    <div className={classes.root} ref={inputRef} id={id}>
      <KeyboardTimePicker
        autoOk
        className={classNames(classes.datepicker, disabled && classes.disabledStyle)}
        variant="inline"
        inputVariant="outlined"
        placeholder={placeholder}
        onChange={onChange}
        format="hh:mm A"
        value={value}
        keyboardIcon=""
        invalidDateMessage={null}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        onBlur={onBlur}
      />
      <IconButton className={classes.iconButton} onClick={disabled ? null : handleClick}>
        <TimeIcon className={classes.timeIcon} />
      </IconButton>
      <TimeSelectPop
        onChange={onChange}
        value={value}
        anchorEl={anchorEl}
        closePop={handleClose}
        m="0 0 0 -1rem"
        disableFuture={disableFuture}
        date={date}
      />
    </div>
  );
}
